import { defineCustomElement } from "vue";
import { Register } from "..";
import PaginationCe from "./PaginacaoComponente.ce.vue";

const tag = "vc-pagination-custom";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(PaginationCe));
  }
};

export default _register;
